import { memo } from 'react';

import { useAppSelector } from '../../../../modules/hooks';
import { selectHasWatchtimeHistory } from '../../../../modules/watchtime';
import { useIdentity } from '../../../IdentityProvider/IdentityProvider';
import { LoginList } from '../LoginList/LoginList';

import { ContinueWatching } from './ContinueWatching';

import type { FC } from 'react';
import type { ContinueWatchingProps } from './ContinueWatching';

export const ContinueWatchingWrapperBase: FC<ContinueWatchingProps> = (
  props
) => {
  const { isLoggedIn } = useIdentity();
  const hasWatchtimeHistory = useAppSelector(selectHasWatchtimeHistory);

  if (!isLoggedIn) {
    return <LoginList />;
  }

  if (hasWatchtimeHistory) {
    return <ContinueWatching {...props} />;
  }

  return null;
};

export const ContinueWatchingWrapper = memo(ContinueWatchingWrapperBase);
